// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gntv_submit-button__button{font-size:14px;font-weight:400;cursor:pointer;width:80px;height:30px;padding:.5em 0;background-color:#5e4d80;color:#d6cfe2;outline:none;border:none;border-radius:5px;transition:background-color 150ms cubic-bezier(0.87, 0, 0.13, 1)}.gntv_submit-button__button:hover{background-color:#524370;color:#d6cfe2}.gntv_submit-button__button:focus-within{box-shadow:0 0 0 2px #75609f;background-color:#463960}", ""]);
// Exports
module.exports = exports;
